/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import { viewTypographyStyles } from "../reports/styles";

export const SalesCategoryPage = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const filterContainerStyle = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", md: "center" },
  gap: { xs: 2, md: 0 }
}

export const filterSectionStyle = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: { xs: 2, sm: "18px" },
  flexWrap: "wrap",
  width: { xs: "100%", md: "auto" },
  flex: 1
}

export const typographyStyle = {
  ...viewTypographyStyles,
  alignSelf: { xs: "flex-start", sm: "center" },
  whiteSpace: "nowrap",
  mt: 0
}

export const menuPropStyle = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: { sx: { maxHeight: "40vh", minWidth: '240px' } },
  autoFocus: false,
  MenuListProps: { sx: { pt: 0 } },
}

export const actionSectionStyle = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  alignSelf: { xs: "flex-start", md: "center" },
  mt: { xs: 1, md: 0 },
  width: { xs: "100%", md: "auto" },
  justifyContent: { xs: "flex-start", md: "flex-end" }
}

export const titleSectionStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '18px',
  flexWrap: 'wrap',
  mt: 2,
}

export const pageTitleStyle = {
  fontSize: '1.4rem',
  fontWeight: 600,
  padding: '22px 0px 10px 0px',
  whiteSpace: 'nowrap',
}

export const FetchButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  marginBottom: '10px',
  gap: '10px',
})

export const fetchButtonStyle = {
  background: "#2b4fb9",
}
